import script from "./SidenavCollapseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavCollapseItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__